import expandProps from "@store/Framework/Common/Utilities/expandProps";
import { IsEmptyType, NoInfer } from "@store/Framework/Types/Common";
import { useMemo } from "react";

export interface ExpandStyles<T> {
    extendedStyles?: IsEmptyType<T, undefined>;
    overridedStyles?: IsEmptyType<T, undefined>;
}

const useExpandProps = <T>(
    baseProps: T,
    extendedProps: NoInfer<T> | undefined,
    overridedProps: NoInfer<T> | undefined,
): T => {
    return useMemo(
        () => expandProps(baseProps, extendedProps, overridedProps),
        [baseProps, extendedProps, overridedProps],
    );
};

export default useExpandProps;
